import React from "react";
import { Typography, Box, Button } from "@mui/material";
import { StepContainer } from "./StepContainer";
import { StatCard, StatusBadge } from "../styled";
import { PreviousExport, Step } from "../types";

interface ExportSummaryStepProps {
  selectedExport: PreviousExport | null;
  onDownloadCsv?: (runId: string) => Promise<void>;
  handleBack: () => void;
  setCurrentStep: (step: Step) => void;
  isFromArchivedExport?: boolean;
}

export const ExportSummaryStep: React.FC<ExportSummaryStepProps> = ({
  selectedExport,
  onDownloadCsv,
  handleBack,
  setCurrentStep,
  isFromArchivedExport = false
}) => {
  const handleSelectNewMatchingRound = () => {
    setCurrentStep(Step.SELECT_MATCHING_ROUND);
  };
  if (!selectedExport) {
    return (
      <StepContainer
        rightPanel={
          <Box sx={{ width: '100%', textAlign: 'center', py: 4 }}>
            <Typography variant="h6" sx={{ fontSize: '16px', fontWeight: 500, mb: 2 }}>
              No export selected
            </Typography>
            <Button
              variant="contained"
              onClick={handleBack}
              sx={{
                bgcolor: '#2167e2',
                '&:hover': { bgcolor: '#1a52b3' },
                textTransform: 'none',
                fontWeight: 400,
                fontSize: '14px',
                padding: '8px 16px'
              }}
            >
              Back to Previous Exports
            </Button>
          </Box>
        }
      />
    );
  }

  const handleDownloadClick = async () => {
    if (onDownloadCsv && selectedExport.runId) {
      await onDownloadCsv(selectedExport.runId);
    }
  };

  const rightPanel = (
    <Box sx={{ width: '100%' }}>
      <Box sx={{
        display: 'flex',
        gap: '16px',
        mb: 3,
        alignItems: 'stretch'
      }}>
        <StatCard>
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 600,
              color: '#1e3a5f',
              lineHeight: 1.5
            }}
          >
            {selectedExport.successfulGroups} Roommate Groups Created in Entrata
          </Typography>
          <StatusBadge variant="success">
            Creation Succeeded
          </StatusBadge>
        </StatCard>

        <StatCard>
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 600,
              color: '#1e3a5f',
              lineHeight: 1.5
            }}
          >
            {selectedExport.unsuccessfulGroups} Roommate Groups Not Created in Entrata
          </Typography>
          <StatusBadge variant="error">
            Creation Failed - Details In Log
          </StatusBadge>
        </StatCard>

        <StatCard>
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 600,
              color: '#1e3a5f',
              lineHeight: 1.5
            }}
          >
            {selectedExport.singleResidents} Not Exported Single Residents
          </Typography>
          <StatusBadge variant="error">
            Not sent
          </StatusBadge>
        </StatCard>
      </Box>

      <Box display="flex" gap={2}>
        <Button
          variant="outlined"
          onClick={handleSelectNewMatchingRound}
          sx={{
            borderColor: '#1e3a5f',
            color: '#1e3a5f',
            '&:hover': {
              borderColor: '#1e3a5f',
              bgcolor: 'rgba(30, 58, 95, 0.04)'
            },
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '14px',
            padding: '10px 24px',
            borderRadius: '8px'
          }}
        >
          {isFromArchivedExport ? 'Back to Previous Lists' : 'Select New Matching Round'}
        </Button>
        <Button
          variant="contained"
          onClick={handleDownloadClick}
          sx={{
            bgcolor: '#2167e2',
            '&:hover': { bgcolor: '#1a52b3' },
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '14px',
            padding: '10px 24px',
            borderRadius: '8px',
            boxShadow: 'none'
          }}
        >
          View Export Log
        </Button>
      </Box>
    </Box>
  );

  return (
    <StepContainer rightPanel={rightPanel} />
  );
};
